import styled, { css } from 'styled-components';

export const TableWrapperStyled = styled.div<{ isEditMode?: boolean }>`
  ${({ isEditMode }) => {
    return (
      !isEditMode &&
      css`
        border-radius: 8px;
        border-width: 2px;
        border-color: var(--ds-border, var(--ds-fb-border));
        border-style: solid;
      `
    );
  }}

  margin-top: 20px;
`;

export const TableHeaderStyled = styled.div`
  margin: 16px 16px 23px 16px;
  display: flex;
  justify-content: space-between;
`;
